export default __webpack_public_path__ + "static/pattern-navy-0ff1f5ee06a926ba6c207e4bd1a26cbc.png";